<script lang="ts">
    import {
        NowPlayingView,
        fullScreenPlayerState,
    } from '~/stores/full-screen-player';
    import { getI18n } from '~/stores/i18n';
    import { createEventDispatcher } from 'svelte';
    import InvertibleMask from '@amp/web-app-components/src/components/InvertibleMask/InvertibleMask.svelte';
    import UpNextIcon from '@amp/web-app-components/assets/icons/up-next-semibold.svg';
    import InfoButton from './InfoButton.svelte';

    const i18n = getI18n();
    const dispatch = createEventDispatcher();

    $: queueButtonAriaLabel = $i18n.t('ASE.Web.MusicClassical.UpNext.Heading');

    $: nowPlayingView = $fullScreenPlayerState.nowPlayingView;
    $: showInfo = nowPlayingView === NowPlayingView.Info;

    const toggleView = (view: NowPlayingView) => {
        dispatch('toggleView', view);
    };
</script>

<div class="toggle-buttons" data-testid="toggle-buttons">
    <InfoButton
        isSelected={showInfo}
        on:click={() => toggleView(NowPlayingView.Info)}
    />

    <button
        data-testid="queue-button"
        aria-label={queueButtonAriaLabel}
        class="toggle-button toggle-button--queue"
        on:click={() => toggleView(NowPlayingView.Queue)}
    >
        <InvertibleMask
            maskSvg={UpNextIcon}
            maskWidth={20}
            maskHeight={20}
            inverted={nowPlayingView === NowPlayingView.Queue}
        />
    </button>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    .toggle-buttons {
        margin-top: 26px;
        display: flex;
        justify-content: space-around;
        mix-blend-mode: plus-lighter;
    }

    .toggle-button {
        --svgFill: var(--systemSecondary-onDark); // Fill for punch-out SVG
        height: 28px;
        width: 28px;
        line-height: 0;
        border-radius: $global-border-radius-medium;
    }

    .toggle-button--queue {
        position: relative;
        z-index: var(--z-default);
    }

    @media (prefers-contrast: more) {
        .toggle-buttons {
            mix-blend-mode: normal;
        }

        .toggle-button {
            --svgFill: var(--keyColor);
        }
    }
</style>
